import React from "react";
// @ts-ignore
import ReactHtmlParser from "react-html-parser";
import SweetAlert2 from 'react-sweetalert2';
import { replace, size } from "lodash";

/**
 * @param props
 * @constructor
 */
 export class ProductMemberPricing extends React.Component<any, any> {
	private _price:any;
	private _label:any;
	private _final_price:any;
	private _regular_price:any;

	constructor(props:any) {
		super(props);

		const { product } = props;
		
		this._price = parseFloat( props.productPrice );
		this._label = ( this._price <= 0 ) ? 'ENROLLED' : 'PURCHASED';
		this._final_price = 'FREE';
		this._regular_price = 'FREE';
		if(product.product_meta.session_sold_individually === '1'){
			this._final_price = ReactHtmlParser(props.productPriceText);
			this._regular_price = ReactHtmlParser(props.productRegularPrice);
		} else if (this._price > 0) {
			this._final_price = ReactHtmlParser(props.productPriceText);
			this._regular_price = ReactHtmlParser(props.productRegularPrice);
		}

		this.state = {
            swal: {
				showConfirmButton: false,
				text: '',
				didClose: () => {
					this.setState((prevState:any) => {return {swal: {...prevState.swal, show: false}}});
				},
			},
        }
	}

	updateSwal = () => {
		var alreadyFoundBestPrice = false;
		const sorted_prices = [
			{
				'0': 'General price',
				'1': this.props.productPriceText,
				'raw_value': parseFloat(this.props.productPrice),
				'current_user_has_access': true,
			},
			...(
				[
					...this.props.productMemPrice
				]
				.sort((a:any, b:any) => { 
					a['raw_value'] = parseFloat(a['raw_value']);
					b['raw_value'] = parseFloat(b['raw_value']);
					return (a['raw_value'] > b['raw_value']) ? 1 : ((a['raw_value'] < b['raw_value']) ? -1 : 0);
				})
				.map(item => {
					const isBestPrice = !alreadyFoundBestPrice && item.current_user_has_access;
					if(isBestPrice){
						alreadyFoundBestPrice = true;
					}
					return {
						...item,
						isBestPrice
					}
				})
			)
		];

		this.setState((prevState:any) => {
			const swal = {
				...prevState.swal,
				title: 'Member Pricing',
				show:true,
				width:600,
				showCloseButton: true,
				customClass: {
					closeButton: 'member-pricing-modal-close-button',
				},
				children: (
					<>
						<table className='member-pricing-table' style={{width: '100%'}}>
							<thead>
								<tr>
									<th> Registration Fee </th>
									<th> Price </th>
								</tr>
							</thead>
							<tbody>
								{sorted_prices.map((item:any) => {
									return (
										<tr style={{backgroundColor: item.isBestPrice ? '#cff2b1' : 'transparent'}} title={item.isBestPrice ? 'This is the price that will be applied' : ''}>
											<td>
												{item[0]}
											</td>
											<td>
												{replace(item[1], '&#36;', '$') }
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</>
				)
			}

			return {swal}
		});
	}

	// @TODO add more complex checkings for price showing, too simple currently, not taking membership prices in account or sessions existence in some cases

	render(): React.ReactNode {
		return (
			<>
				<SweetAlert2 {...this.state.swal}></SweetAlert2>
				<div className='vmh_accent_text price_wrapper' style={{display:'inline', padding:'0', float: 'left'}}>
					{ this.props.productPurchased ?
						<label style={{display:'inline-block', fontSize: '12px', fontWeight: 400, color:'#016198'}}>{this._label}</label>
						: <>
							{ (this.props.productMemPrice.length > 0 && (this.props.product.session_sold_individually != '1')) ?
								<>
									<label onClick={this.updateSwal} data-view-pricing="" className='member-pricing-link' style={{cursor:'pointer'}}>&#x203A; VIEW PRICING</label>
								</>
								: <>
									{/* { this.props.productRegularPrice > 0 ?
										<> */}
											<label style={{display:'inline-block', fontSize:'19px',fontWeight:'400', color:'#016198', textDecoration:'line-through'}}>{this._regular_price}</label>
										{/* </> : null
									} */}
									<label style={{display:'inline-block', fontSize:'19px',fontWeight:'400', color:'#016198'}}>{this._final_price}</label>
								</>
							}
						</>
					}
				</div>
			</>
		);
	}
}

